import getFileOnS3 from './getFileOnS3';
import getImageOnS3 from './getImageOnS3';
import postFileToS3 from './postFileToS3';

export default {
  getFileOnS3,
  getImageOnS3,
  postFileToS3,
};



// WEBPACK FOOTER //
// ./src/app/services/amazonAWS/index.js